const editJavascriptAlert = () => {

    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const data = JSON.parse(localStorage.getItem('data'));
    if( selectedPage > -1){
        const { javascript } = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage];
        if(javascript.changeJavascript === false){
            data[selectedProject].pages[selectedPage].javascript.changeJavascript = true;
            localStorage.setItem('data', JSON.stringify(data)); 
        }
    }
}

const createJavascriptOnAddFileType = (component) => {
    if(component.attributes.attributes.type === 'file'){
        editJavascriptAlert();
    }
}   

const createJavascriptOnAddDateField = (component) => {
    if(String(component.attributes.attributes.id).startsWith('datepicker') === true){
        editJavascriptAlert();
    }
}

const handleAddJavascriptOnAddComponent = (editor) => {

    editor.on('component:add', (component) => {

        createJavascriptOnAddFileType(component);
        createJavascriptOnAddDateField(component);
    })

}

export default handleAddJavascriptOnAddComponent;
